/* eslint-disable no-case-declarations */
import { combineReducers } from 'redux';
import {
  FETCH_ANNOUNCEMENTS_SUCCESS,
  FETCH_ANNOUNCEMENTS_REQUEST,
  FETCH_ANNOUNCEMENTS_FAILURE,
  ANNOUNCEMENT_UPDATE,
  DISMISS_ANNOUNCEMENT,
} from '../../constants/ActionTypes';
import {
  updateAnnouncements,
  updateAnnouncementsSocketData,
  updateDismissAnnouncements,
} from './updators';

const list = (
  state = { data: {}, isFetching: false, error: {}, updatedAt: null },
  action
) => {
  switch (action.type) {
    case FETCH_ANNOUNCEMENTS_REQUEST:
      return { ...state, isFetching: true, error: {} };
    case FETCH_ANNOUNCEMENTS_SUCCESS:
      const dataFetchAnnouncements = updateAnnouncements(state, action);

      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: dataFetchAnnouncements,
        updatedAt: Date.now(),
      };
    case FETCH_ANNOUNCEMENTS_FAILURE:
      return { ...state, isFetching: false, error: action.data };
    case DISMISS_ANNOUNCEMENT: {
      const dataDismissAnnouncements = updateDismissAnnouncements(
        state,
        action.id
      );

      return {
        ...state,
        data: dataDismissAnnouncements,
        updatedAt: Date.now(),
      };
    }
    case ANNOUNCEMENT_UPDATE: {
      const dataAnnouncementsSocketData = updateAnnouncementsSocketData(
        state,
        action
      );

      return {
        ...state,
        data: dataAnnouncementsSocketData,
        updatedAt: Date.now(),
      };
    }
    default:
      return state;
  }
};

const announcements = combineReducers({
  list,
});

export default announcements;
